import React from 'react';
import PropTypes from 'prop-types';
import { Button } from './style';

function CustomLink({
  style,
  text,
  action,
  darkMode,
  active,
  sectionName,
  href,
  rel,
  target,
}) {
  const handleClick = (event) => {
    if (sectionName && href.startsWith('#')) {
      event.preventDefault();
      // Keep the hash for deep-linking while preserving smooth scroll behavior.
      if (window.location.hash !== href) {
        window.history.replaceState(null, '', href);
      }
    }

    action();
  };

  return (
    <Button
      href={href}
      rel={rel}
      target={target}
      style={style}
      onClick={handleClick}
      active={active}
      darkMode={darkMode}
    >
      {text}
    </Button>
  );
}

CustomLink.defaultProps = {
  text: '',
  sectionName: '',
  href: '#',
  target: '_self',
  rel: undefined,
  style: {},
  action: () => null,
  darkMode: false,
  active: false,
};

CustomLink.propTypes = {
  sectionName: PropTypes.string,
  href: PropTypes.string,
  rel: PropTypes.string,
  target: PropTypes.string,
  text: PropTypes.string,
  style: PropTypes.shape({ root: PropTypes.string }),
  action: PropTypes.func,
  darkMode: PropTypes.bool,
  active: PropTypes.bool,
};

export default CustomLink;
